import React from "react";
import {
  statusSelectOptions,
  CONTINUE_MONITORING,
  SUCCESS,
  IN_PROGRESS,
  AWAITING_APPROVAL,
  APPROVED,
  NO_FURTHER_ACTION,
  NO_ACTION,
  CLIENT_REVIEW,
  SELF_RESOLVED,
  PURCHASE,
  TP_Approve,
  TP_InProgress,
  TP_Success,
  TP_Client_Review,
  TP_No_Action,
  TP_No_Further_Action,
  PURCHASE_IN_PROGRESS,
  PURCHASE_IN_COMPLETE,
  PURCHASE_INCOMPLETE_PRODUCT_NOT_AVAILABLE,
  PURCHASE_INCOMPLETE_SELLER_NOT_RESPONSIVE,
} from "../infrigementStatusCode";

const PLACEHOLDER = "Select from dropdown";

// what this select offered before statuses came from the server
const legacyStatuses = (platform) => [
  CONTINUE_MONITORING,
  SUCCESS,
  IN_PROGRESS,
  AWAITING_APPROVAL,
  APPROVED,
  NO_FURTHER_ACTION,
  NO_ACTION,
  CLIENT_REVIEW,
  SELF_RESOLVED,
  ...(platform === "e-commerce"
    ? [
        PURCHASE,
        TP_Approve,
        TP_InProgress,
        TP_Success,
        TP_Client_Review,
        TP_No_Action,
        TP_No_Further_Action,
        PURCHASE_IN_PROGRESS,
        PURCHASE_IN_COMPLETE,
        PURCHASE_INCOMPLETE_PRODUCT_NOT_AVAILABLE,
        PURCHASE_INCOMPLETE_SELLER_NOT_RESPONSIVE,
      ]
    : []),
];

// the status a user picks for a record of one company on one platform
function StatusSelect({ platform, companyId, value, onChange }) {
  const options = statusSelectOptions({ platform, companyId }, () => legacyStatuses(platform)).filter((status) => status.code !== "");

  return (
    <select value={value || PLACEHOLDER} onChange={onChange} className="form-control">
      <option>{PLACEHOLDER}</option>
      {options.map((status) => (
        <option key={status.code} value={status.code}>
          {status.text}
        </option>
      ))}
    </select>
  );
}

export default StatusSelect;
